import {ElementRef, Injectable} from "@angular/core";

interface IIntElementSize {
  width: number,
  height: number
}

@Injectable()
export class IntElementSizeService {
  constructor(
    private readonly elementRef: ElementRef
  ) {
  }
  get(): IIntElementSize {
    const {width, height} = this.elementRef.nativeElement.getBoundingClientRect();
    return {
      width,
      height
    }
  }
}
